import { ItemResponse, SuccessResponse, WithUpdate } from '@bv/api';
import { WithCreate, WithDelete, WithShow, WithList } from '@bv/api/crud';
import { mixinClass } from '@bv/utils/common/mixin-class';

/**
 * Manages AI agents.
 */
class AiAgentApi extends mixinClass(
  WithList<AiAgentListItem>,
  WithShow<AiAgent>,
  WithCreate<AiAgent>,
  WithUpdate<AiAgent>,
  WithDelete<AiAgent>,
) {
  public constructor(public endpoint = 'ai-agent/agents') {
    super(endpoint);
  }

  public async updateStatus(id: AiAgentListItem['id'], is_active: boolean): Promise<SuccessResponse> {
    return this.request({ method: 'patch', url: `${id}/status`, data: { is_active } });
  }

  public async clone(id: AiAgentListItem['id']): Promise<AiAgentListItem> {
    return this.request<AiAgentListItem, ItemResponse<AiAgentListItem>>({
      method: 'post',
      url: `${id}/clone`,
    }).then((response) => response.data);
  }

  public async startWebRtcTest(id: AiAgentListItem['id']): Promise<AiVoiceAgentWebRtcTestData> {
    return this.request<AiVoiceAgentWebRtcTestData, ItemResponse<AiVoiceAgentWebRtcTestData>>({
      method: 'get',
      url: `${id}/webrtc`,
    }).then((response) => response.data);
  }
}

export const aiAgentApi = new AiAgentApi();
